module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
 var selectedClass = '';
 if (node.selected) {
     selectedClass = 'bg-success';
 }

 
    ; __append("\r\n\r\n<li role=\"button\" class=\"has-menu ")
    ; __append(escapeFn( selectedClass ))
    ; __append(" ")
    ;  if(node.nodeType === 'attn'){ 
    ; __append("draggableItem")
    ;  } else if (node.nodeType === 'group') { 
    ; __append("droppableContainer")
    ;  } 
    ; __append("\"  >\r\n    <i  data-toggle=\"collapse\" data-target=\"#well")
    ; __append(escapeFn(node.id))
    ; __append("\" data-itemid=\"")
    ; __append(escapeFn(node.id))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(node.groupType))
    ; __append("\" data-nodeType=\"")
    ; __append(escapeFn(node.nodeType))
    ; __append("\" data-parentId=\"")
    ; __append(escapeFn(node.parentId))
    ; __append("\" class=\"switch collapsed ")
    ; __append(escapeFn(node.toggleIcon))
    ; __append("\"></i>\r\n    <span class=\"icon ")
    ; __append(escapeFn(node.icon))
    ; __append("\"></span>\r\n    <a data-linkid=\"")
    ; __append(escapeFn(node.linkId))
    ; __append("\" class=\"item-link\" data-itemid=\"")
    ; __append(escapeFn(node.id))
    ; __append("\" data-target=\"#well")
    ; __append(escapeFn(node.id))
    ; __append("\" data-groupType=\"")
    ; __append(escapeFn(node.groupType))
    ; __append("\" data-nodeType=\"")
    ; __append(escapeFn(node.nodeType))
    ; __append("\" data-parentId=\"")
    ; __append(escapeFn(node.parentId))
    ; __append("\" role=\"\" title=\"")
    ; __append(escapeFn(node.nodeName))
    ; __append("\">\r\n        ")
    ; __append(escapeFn(node.nodeName))
    ; __append("\r\n    </a>\r\n</li>\r\n\r\n")
    ;  if (node.nodes && node.nodes.length === 0) { 
    ; __append("\r\n    <div id=\"well")
    ; __append(escapeFn(node.id))
    ; __append("\" class=\"bo-body collapse\">\r\n        <ul class=\"group-items\"></ul>\r\n    </div>\r\n")
    ;  } 
  }
  return __output;

}